import { useMemo } from 'react';
import PropTypes from 'prop-types';
import { sort } from 'ramda';
import { isNilOrEmpty } from 'ramda-extension';

import useFormData from '@gef-ui/form-core/hooks/state/useFormData';
import { getLabelMessage } from '@gef-ui/localization/messages';

import AutocompleteCustomOptionKey from 'components/atoms/GefMui/AutocompleteCustomOptionKey';
import codelistProvider from 'components/decorators/codelistProvider';
import { codelists } from 'constants/codelists';
import { FIELDS } from 'features/views/policyOverview/form';
import { sortAlphabeticallyBy } from 'utils';
import { joinString } from 'utils/string';

const ProductAutoComplete = ({ productsCodelist }) => {
	const formData = useFormData();

	const productOptions = useMemo(() => {
		let filteredItems;
		if (!isNilOrEmpty(formData?.productDomain)) {
			filteredItems = productsCodelist.filter((item) => {
				return (
					item.shortDescription &&
					item.productDomainIds &&
					item.productDomainIds
						.split(',')
						.map((id) => +id)
						.includes(+formData?.productDomain)
				);
			});
		} else {
			filteredItems = productsCodelist;
		}

		const productOptionsFullName = filteredItems.map((item) => ({
			...item,
			fullName: joinString(' - ', [item?.shortDescription, item?.jokName]),
		}));

		return sort(sortAlphabeticallyBy('fullName'))(productOptionsFullName);
	}, [formData, productsCodelist]);

	return (
		<AutocompleteCustomOptionKey
			size="small"
			fieldName={FIELDS.product}
			label={getLabelMessage('policyOverview:product')}
			options={productOptions}
			labelPropName="fullName"
			keyPropName="id"
		/>
	);
};

ProductAutoComplete.propTypes = {
	productsCodelist: PropTypes.array,
};

export default codelistProvider(codelists.products, 'productsCodelist', true)(ProductAutoComplete);
